import React from 'react';
import { tramoHora } from '../../modules/Reports/containers/TicketSales';
import { fechasIguales } from '../../modules/Reports/containers/TicketRenderModal';
import { t, T } from '../../helpers/i18n';
import { toDate, toDateTime } from '../../helpers/Format';
import { Texto } from './Texto';
import { BlockSpaces } from './Blocks/BlockSpaces';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
export var RenderExpiration = function (_a) {
    var _b, _c, _d, _e, _f;
    var item = _a.item;
    var timeExpiration = item.timeExpiration, timeUse = item.timeUse;
    // console.log('dateExpiration', timeExpiration)
    // console.log('renderExpiration - item: ', item)
    var datebook = new Date((_b = item.year) !== null && _b !== void 0 ? _b : item.datebook.getFullYear(), (_c = item.month) !== null && _c !== void 0 ? _c : item.datebook.getMonth(), (_d = item.day) !== null && _d !== void 0 ? _d : item.datebook.getDate(), (_e = item.hours) !== null && _e !== void 0 ? _e : item.datebook.getHours(), (_f = item.minutes) !== null && _f !== void 0 ? _f : item.datebook.getMinutes(), 0, 0);
    var expiration = item.datebook ? datebook : item.datecheck; // new Date(item.datevalited ? item.datevalited : item.datebook? datebook : item.datecheck)
    var book = item.datebook ? datebook : item.datecheck;
    // fechas (expiration, timeuse ....)
    if (item.hoponHopoff) { // hoponhopoff
        // Si no ha sido validado: Se muestra el tiempo hasta que se puede validar y el tiempo de uso una vez validado
        // si timeExpiration === 0 la validación tiene que ser en el día.
        // Si ya se ha validado: Se muestra el tiempo de uso que tiene (24 horas, 48 horas, mismo día) y el tiempo hasta el que se puede usar
        // no se tiene en cuenta el timeExpiration. Si timeUse === 0 es hasta las 23:59:59. Si timeUse !== 0 es datevalited más timeUse.
        if (!item.datevalited) {
            if (item.timeExpiration === 0) { // resto del día
                expiration.setHours(23);
                expiration.setMinutes(59);
                expiration.setSeconds(59);
                expiration.setMilliseconds(999);
            }
            else {
                // Está en el rango de fecha de emisión y el timeExpiration
                expiration.setDate(expiration.getDate() + item.timeExpiration);
                expiration.setHours(new Date(item.datecheck).getHours());
                expiration.setMinutes(new Date(item.datecheck).getMinutes());
                expiration.setSeconds(59);
                expiration.setMilliseconds(999);
            }
        }
        else { // Está en el rango de fecha de validación y tiempo de uso
            var valited = new Date(item.datevalited);
            expiration.setHours(valited.getHours() + timeUse);
        }
    }
    else if (item.tramoHora) { // no es hoponhopoff, es ida o ida-vuelta
        // Aquí hay que controlar el tiempo que pasa después de la hora de uso para dar por
        // buena la validación, si es 0 es inmediato, si tiene valor es la hora de uso
        // más los minutos en timeExpiration
        expiration.setDate(expiration.getDate() + item.timeExpiration);
    }
    else {
        if (timeExpiration > 0) {
            expiration.setHours(23, 59, 59, 999);
            expiration.setDate(expiration.getDate() + timeExpiration);
        }
    }
    // console.log('Papel - renderExpiration - timeExpiration: ', item.timeExpiration)
    if (item.tramoHora) { // tiene hora de
        if (!item.datebook) { // pertenece a un paquete que no tiene fecha de uso
            if (item.vuelta) {
                if (item.timeExpiration === 0) {
                    return (React.createElement("div", { style: { marginTop: 0 } },
                        React.createElement("h6", null,
                            React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
                        React.createElement("h6", null,
                            React.createElement("p", { style: { textAlign: 'start' } },
                                T('parael'),
                                " ",
                                toDate(expiration)),
                            React.createElement("p", null, 'sujeto a plazas disponibles en el momento del uso'))));
                }
                else {
                }
            }
            else {
                if (item.timeExpiration === 0) {
                    return (React.createElement("div", { style: { marginTop: 0 } },
                        React.createElement("h6", null,
                            React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
                        React.createElement("h6", null,
                            React.createElement("p", { style: { textAlign: 'start' } },
                                T('parael'),
                                " ",
                                toDate(expiration))),
                        React.createElement("h6", null,
                            React.createElement("p", null, 'sujeto a plazas disponibles en el momento del uso'))));
                }
                else {
                    return (React.createElement(TramohoraVueltaNodatebookIdaExpirationNo0, { item: item, expiration: expiration }));
                }
            }
            return React.createElement("h6", null,
                React.createElement("p", null, 'sujeto a plazas disponibles en el momento del uso'));
        }
        var tramoHorario = tramoHora(typeof item.datebookNTZ === 'string' ? new Date(item.datebookNTZ) : item.datebookNTZ, item.hours, item.minutes);
        if (item.vuelta) { // hora de uso con ida y vuelta
            return (React.createElement("div", { style: { marginTop: 0 } },
                React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
                fechasIguales(typeof item.datebook === 'string' ? new Date(item.datebook) : item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('parael'),
                        " ",
                        toDate(expiration))),
                !fechasIguales(typeof item.datebook === 'string' ? new Date(item.datebook) : item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('desde'),
                        " ",
                        toDate(item.datebook),
                        " a las ",
                        tramoHorario,
                        " ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("br", null),
                        " ",
                        T('hasta'),
                        " ",
                        toDate(expiration),
                        React.createElement("br", null)))));
        }
        else { // hora de uso sólo ida
            return (React.createElement("div", { style: { marginTop: 0 } },
                !item.vuelta && React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
                React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('parael'),
                        " ",
                        toDate(item.datebook),
                        " a las ",
                        tramoHorario,
                        " horas"))));
        }
    }
    else {
        // no tiene hora de uso, es un ticket normal o hoponhopoff
        // Si tiene datebook la expiración será la fecha del datebook más el timeUse, a no ser que timeExpiration sea 0 y entonces es el resto del día
        // Si tiene datebook y no datevalited la expiración será la caducidad, y si tiene datevalited sera la fecha del datebook más el timeUse,
        // a no ser que timeExpiration sea 0 y entonces es el resto del día
        // Si no tiene datebook se muestra el plazo para validarlo por primera vez
        // console.log('item.datebook && item.datevalited && item.timeExpiration>0', (item.datebook && item.datevalited && item.timeExpiration>0)? 'true': 'false')
        if (item.hoponHopoff) {
            if (item.datevalited) {
                return (React.createElement("div", null,
                    React.createElement(Texto, { texto: 'HopON HopOFF', align: Align.Center, fontSize: FontSize.big, bold: true }),
                    React.createElement(BlockSpaces, null),
                    React.createElement(Texto, { texto: "".concat(T('paraUsarEntre'), "} ").concat(toDateTime(item.datevalited), " ").concat(t('yEl'), " ").concat(toDateTime(expiration)) })));
            }
            else {
                return (React.createElement("div", null,
                    React.createElement(Texto, { texto: 'HopON HopOFF', align: Align.Center, fontSize: FontSize.big, bold: true }),
                    React.createElement(BlockSpaces, null),
                    React.createElement(Texto, { bold: true, texto: "".concat(T('paraValidarEntre'), " ").concat(toDateTime(item.datebook), " ").concat(t('yEl'), " ").concat(toDateTime(expiration)) }),
                    React.createElement(BlockSpaces, null),
                    React.createElement(Texto, { bold: true, texto: "".concat(T('timeUse'), " ").concat(item.timeUse, " ").concat(t('hours'), " ").concat(t('aPartirValidacion')) }),
                    React.createElement(BlockSpaces, null),
                    React.createElement(Texto, { texto: 'sujeto a plazas disponibles en el momento del uso' })));
            }
        }
        else { // normal o ida y vuelta
            return (React.createElement("div", { style: { marginTop: 0 } },
                !item.vuelta && React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
                " ",
                item.vuelta && React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
                " ",
                item.datebook && fechasIguales(typeof book === 'string' ?
                    new Date(book) : book, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('parael'),
                        " ",
                        toDate(expiration))),
                item.datebook && !fechasIguales(typeof book === 'string' ?
                    new Date(book) : book, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('desde'),
                        " ",
                        toDate(book),
                        " ",
                        T('hasta'),
                        " ",
                        toDate(expiration)))));
        }
    }
};
var HopOnOff = function (_a) {
    var child = _a.child;
    return (React.createElement("div", { style: { marginTop: 0 } }, child));
};
var HopValitedDatebookTimeexpiration0Timeuse0 = function (_a) {
    var item = _a.item, expiration = _a.expiration;
    return (React.createElement("h6", null,
        React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
            T('paraUsarEntre'),
            " ",
            toDateTime(item.datevalited),
            " ",
            t('yEl'),
            " ",
            toDateTime(expiration))));
};
var HopNovalitedDatebookTimeexpiration0TimeuseNo0 = function (_a) {
    var item = _a.item, expiration = _a.expiration;
    return (React.createElement("h6", null,
        React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'start' } },
            T('paraValidarEntre'),
            " ",
            toDateTime(item.datebook),
            " ",
            t('yEl'),
            " ",
            toDateTime(expiration)),
        React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'start' } },
            T('timeUse'),
            " ",
            toDateTime(item.timeUse),
            " ",
            T('hours'),
            " ",
            t('aPartirValidacion')),
        React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'start' } }, 'sujeto a plazas disponibles en el momento del uso')));
};
var TramohoraVueltaNodatebookIdaExpirationNo0 = function (_a) {
    var item = _a.item, expiration = _a.expiration;
    return (React.createElement("div", null,
        React.createElement("h6", null,
            React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'center' } }, 'Válido para un solo uso'),
            React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'start' } },
                T('paraUsarEntre'),
                " ",
                toDateTime(item.datecheck),
                " ",
                t('yEl'),
                " ",
                toDate(expiration)),
            React.createElement("p", { style: { marginTop: 5, marginBottom: 0, textAlign: 'start' } }, 'sujeto a plazas disponibles en el momento del uso'))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Expiration.tsx
// module id = 251
// module chunks = 0